exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._39DdT{position:relative}.PKOJ_{border-radius:var(--b-space-sm);padding-top:var(--b-space-sm);padding-bottom:var(--b-space-sm);padding-left:var(--b-space-md);padding:var(--b-space-sm) var(--b-space-lg) var(--b-space-sm) var(--b-space-md);padding-right:var(--b-space-lg);line-height:1.3;display:block;width:100%;-webkit-appearance:none;-moz-appearance:none;-o-text-overflow:\"\";text-overflow:\"\";background-color:var(--c-ui-lighter)}.PKOJ_:focus{outline:none}._BHpd{position:absolute;right:var(--b-space-2xs);top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);pointer-events:none}", ""]);

// exports
exports.locals = {
	"root": "_39DdT",
	"select": "PKOJ_",
	"iconDown": "_BHpd"
};